import { ComponentType } from 'react'

import { compose, lifecycle, withProps, withState } from 'recompose'

type Config = {
  loading: ComponentType
  resolver: () => Promise<any>
}

export type Props = {
  asyncComponent: ComponentType
}

type StateProps = {
  setAsyncComponent: (asyncComponent: ComponentType) => void
} & Props

const withAsyncComponent = (config: Config) =>
  compose(
    withState('asyncComponent', 'setAsyncComponent', null),
    lifecycle<StateProps, {}>({
      componentDidMount() {
        config.resolver().then((asyncComponent) => {
          this.props.setAsyncComponent(asyncComponent)
        })
      },
    }),
    withProps<Props, StateProps>((props) => ({
      asyncComponent: props.asyncComponent || config.loading,
    })),
  )

export { withAsyncComponent }
